import {useEffect, useState} from 'react'
import {trackViewProduct, trackViewProductSet} from '../../../tracking/analytics'

import {isProductSet} from '../../../utils/product-utils'
import useEffectEvent from '../../../hooks/use-effect-event'

const useTrackViewPDP = (product) => {
    const [trackedId, setTrackedId] = useState(null)

    const onProductChange = useEffectEvent((product) => {
        // only track if product exists
        // only track once
        if (!product || trackedId === product?.id) {
            return
        }

        if (isProductSet(product)) {
            // track product set
            trackViewProductSet(product)
        } else {
            // track cart
            trackViewProduct(product)
        }
        setTrackedId(product.id)
    })
    useEffect(() => {
        onProductChange(product)
    }, [product, onProductChange])
}

export default useTrackViewPDP
